import styled from 'styled-components';
import { tokens, utils } from '@snsw/react-component-library';

const { gutters } = tokens.layouts.grid;
const wholeGutter = utils.pxToRem(gutters);

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: ${utils.pxToRem(tokens.spacing.md)};
    margin-top: ${utils.pxToRem(tokens.spacing.xxxl)};

    ${utils.getBreakpoint.md`
        flex-direction: row;
    `}

    .button-item:not(:last-child) {
        margin-bottom: ${wholeGutter};

        ${utils.getBreakpoint.md`
            margin-right: ${wholeGutter};
            margin-bottom: 0;
        `}
    }
`;

export default ButtonsContainer;
